/* istanbul ignore file */
import { UntypedFormGroup } from '@angular/forms';

import { Dashboard, FilterMenuOptions, Widget } from '../../../models';

export class DashboardsLogicServiceModel {
    dashboards: Dashboard[] = [];
    dashboardForm: UntypedFormGroup = new UntypedFormGroup({});
    widgetForm: UntypedFormGroup = new UntypedFormGroup({});
    isEditingExistingWidget = false;
    areDashboardsLoading = false;
    dashboardsActivating = new Set<string>();
    currentDashboard?: Dashboard;
    isDashboardInEditMode = false;
    currentDashboardBeforeEditState?: Dashboard;
    areChangesMadeToCurrentDashboard = false;
    projectId: string | null = null;
    loadedSiteMapPinsProjectId: string | undefined;
    mapWidgetCurrentLatLongBounds: google.maps.LatLngBounds | null = null;
    isWidgetExpanded = false;
    widgetInExpandedView?: Widget;
    collapsedWidgetScrollPosition?: number;
    expandedWidgetSourceTooltip?: string;
    expandedWidgetTooltip?: string;
    dashboardFilterMenuOptions: FilterMenuOptions = new FilterMenuOptions();
}
